<div class="grid-container">
  <div class="modal-body">
    <h2 class="text-center">{{ 'language.title' | transloco }}</h2>

    <div class="language-list">
      <button
        *ngFor="let lang of languages"
        class="dropdown-item"
        (click)="setLang(lang.code)"
      >
        <span><img [src]="lang.icon" alt="Lang Icon" /></span>
        <span class="lang-label">{{ lang.label | transloco }}</span>
      </button>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-small" (click)="cancel()">
      {{ 'label.cancel' | transloco }}
    </button>
  </div>
</div>
